// extracted by css-extract-rspack-plugin
export default {"actionMenu":"ePxis"};